import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin, Button } from 'antd';
import { ArrowLeftOutlined, PrinterOutlined } from '@ant-design/icons';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { API_BASE_URL } from '../../utils/config';
import axios from 'axios';

const dilekceStyles = `
.dilekce-container { padding: 20px; }
.dilekce-container .content-wrapper { background-color: var(--color-bg); padding: 20px; }
.dilekce-container.dark .content-wrapper { background-color: var(--dark-bg); }
.izin { width: 100%; border-collapse: collapse; }
.izin td:first-child { width: 250px; }
.izin td { border: 1px solid #929292; padding: 10px; }
.dilekce-container.dark .izin td { border-color: #666; color: #fff; }
.dilekce-container .row { display: flex; flex-wrap: wrap; margin: 0 -15px; }
.dilekce-container .col-sm-1, .dilekce-container .col-sm-2, .dilekce-container .col-sm-3, .dilekce-container .col-sm-10 { padding: 0 15px; flex: 0 0 auto; }
.dilekce-container .col-sm-1 { width: 4.16667%; }
.dilekce-container .col-sm-2 { width: 16.66667%; }
.dilekce-container .col-sm-3 { width: 25%; }
.dilekce-container .col-sm-10 { width: 83.33333%; }
@media print {
  .ant-layout-header, .ant-layout-sider, header, aside { display: none !important; }
  .dilekce-container > div:first-child { display: none !important; }
  .ant-layout, .ant-layout-content, body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
  .dilekce-container { padding: 0; margin: 0; }
  .content-wrapper { background-color: #fff !important; padding: 10px !important; margin: 0 !important; }
  .dilekce-container.dark .content-wrapper { background-color: #fff !important; }
  .dilekce-container.dark .izin td { border-color: #929292; color: #000; }
  .dilekce-container .content-wrapper { display: block !important; }
  @page { margin: 1cm; }
}
`;

const Dilekce = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { getAuthHeaders } = useAuth();
    const { darkMode } = useTheme();
    const [loading, setLoading] = useState(true);
    const [leaveData, setLeaveData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (id) {
            fetchLeaveData();
        }
    }, [id]);

    const fetchLeaveData = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await axios.post(
                `${API_BASE_URL}/list/execute-query/profil-izin-detay`,
                { params: { id: parseInt(id) } },
                { headers: getAuthHeaders() }
            );            
            if (Array.isArray(response.data) && response.data.length > 0) {
                setLeaveData(response.data[0]);
            } else {
                setError('İzin kaydı bulunamadı');
            }
        } catch (error) {
            console.error('İzin verisi yüklenirken hata:', error);
            setError('İzin verisi yüklenirken bir hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString || dateString === '0000-00-00' || dateString === null) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const formatTime = (timeString) => {
        if (!timeString) return '';
        if (typeof timeString === 'string') {
            return timeString.substring(0, 5);
        }
        return timeString;
    };

    const calculateLeaveDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 0;
        const start = new Date(startDate);
        const end = new Date(endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0;
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        return diffDays;
    };

    const calculateAnnualLeaveDays = (startDate, endDate, startTime, endTime) => {
        const days = calculateLeaveDays(startDate, endDate);
        const startTimeStr = String(startTime || '');
        const endTimeStr = String(endTime || '');
        if (days === 1 && 
            !((startTimeStr === '09:00:00' || startTimeStr.startsWith('09:00')) && 
              (endTimeStr === '18:30:00' || endTimeStr.startsWith('18:30')))) {
            return 0;
        }
        return days;
    };

    const handlePrint = () => {
        window.print();
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (error || !leaveData) {
        return (
            <div style={{ padding: '20px' }}>
                <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/profil')} style={{ marginBottom: '20px' }}>
                    Geri Dön
                </Button>
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <p>{error || 'İzin kaydı bulunamadı'}</p>
                </div>
            </div>
        );
    }

    const startDate = leaveData.baslangicTarihi;
    const endDate = leaveData.bitisTarihi;
    const startTime = leaveData.baslangicSaati || '';
    const endTime = leaveData.bitisSaati || '';
    let dateRange = '';
    if (startDate === endDate) {
        dateRange = formatDate(startDate);
    } else {
        dateRange = `${formatDate(startDate)} - ${formatDate(endDate)}`;
    }

    let timeRange = '';
    const startTimeStr = String(startTime || '');
    const endTimeStr = String(endTime || '');
    if ((startTimeStr === '09:00:00' || startTimeStr.startsWith('09:00')) && 
        (endTimeStr === '18:30:00' || endTimeStr.startsWith('18:30'))) {
        timeRange = 'Tüm Gün';
    } else {
        timeRange = `${formatTime(startTime)} - ${formatTime(endTime)}`;
    }

    const totalDays = calculateLeaveDays(startDate, endDate);
    const annualLeaveDays = calculateAnnualLeaveDays(startDate, endDate, startTimeStr, endTimeStr);

    return (
        <>
            <style>{dilekceStyles}</style>
            <div className={`dilekce-container ${darkMode ? 'dark' : ''}`}>
            <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: '20px', padding: '0 20px' }}>
                <Button 
                    icon={<PrinterOutlined />} 
                    onClick={handlePrint}
                    type="primary"
                >
                    Yazdır
                </Button>
            </div>
            
            <div className="content-wrapper">
                <br />
                <center><h1>İzin Dilekçesi</h1></center>
                <br />
                <br />
                <br />
                
                <div className="row">
                    <div className="col-sm-1"></div>
                    <div className="col-sm-10">
                        <table className="izin">
                            <tbody>
                                <tr>
                                    <td><b>Tarih</b></td>
                                    <td>{formatDate(new Date())}</td>
                                </tr>
                                <tr>
                                    <td><b>Adı Soyadı</b></td>
                                    <td>{leaveData.calisan_ad_soyad || ''}</td>
                                </tr>
                                <tr>
                                    <td><b>Görev Yaptığı Ünite</b></td>
                                    <td>{leaveData.departman || ''}</td>
                                </tr>
                                <tr>
                                    <td><b>İzin Tipi</b></td>
                                    <td>{leaveData.izinTipi || ''}</td>
                                </tr>
                                <tr>
                                    <td><b>İzin Sebebi</b></td>
                                    <td>{leaveData.izinSebebi || ''}</td>
                                </tr>
                                <tr>
                                    <td><b>İzinli Bulunacağı Tarih</b></td>
                                    <td>{dateRange}</td>
                                </tr>
                                <tr>
                                    <td><b>İzinli Bulunacağı Saatler</b></td>
                                    <td>{timeRange}</td>
                                </tr>
                                <tr>
                                    <td><b>İzin Süresi</b></td>
                                    <td>{totalDays}</td>
                                </tr>
                                <tr>
                                    <td><b>İzin Süresi (Yıllık İzinden Düşülecek)</b></td>
                                    <td>{annualLeaveDays}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <br />
                <br />
                <br />
                <br />
                
                <div className="row">
                    <div className="col-sm-2"></div>
                    <div className="col-sm-3">
                        <center>
                            <h4>İzin Talep Eden</h4>
                            {leaveData.calisan_ad_soyad || ''}
                            <br />
                        </center>
                    </div>
                    <div className="col-sm-2"></div>
                    <div className="col-sm-3">
                        <center>
                            <h4>Onaylayan</h4>
                            {leaveData.onaylayan_ad_soyad || ''}
                        </center>
                    </div>
                    <div className="col-sm-2"></div>
                </div>
            </div>
            </div>
        </>
    );
};

export default Dilekce;